module.exports = __webpack_public_path__ + "0daf824ba221026049ea76e15c058f13.pdf";